<template>
  <div>
    <LogoHome />
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex v-if="sysNombre == ''">
          <v-progress-circular
            indeterminate
            color="blue"
            :size="60"
            :width="5"
          ></v-progress-circular>
        </v-flex>
        <v-flex v-else>
          <span class="headline font-weight-light">{{ sysNombre }}</span>
          <p class="caption font-weight-light">
            {{ sysDireccionLocalidad }}
            <br />
            {{ sysTelefonoEmail }}
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LogoHome from "@/components/LogoHome";
export default {
  name: "HomeCartera",
  components: {
    LogoHome
  },
  methods: {
    abrirOpcion(ruta) {
      if (ruta != this.$route.name)
        this.$router.push({ name: ruta, params: {} });
    }
  }
};
</script>
